import React, { useEffect, useRef } from 'react';

interface IFakeEditorProps {
    value: string | boolean | number | Date;
    label: string;
}

export const FakeEditor = ({ value, label }: IFakeEditorProps): JSX.Element => {
    const quillRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (quillRef.current) {
            if (value !== '<p><br></p>') {
                quillRef.current.innerHTML = `${value}`;
            } else {
                quillRef.current.innerHTML = `<p>-</p>`;
            }
        }
    }, [quillRef, value]);

    return (
        <div className="col-12 fv-row input-container mb-7">
            <div className="form-label  col-12">
                {
                    label && (
                        <span className="text-muted fs-6">{label}</span>
                    )
                }
                <div className="mb-3 mt-1 fs-6" ref={quillRef}/>
            </div>
        </div>
    );
};
